<template>
  <el-table
    :data="tableData"
    class="szTable"
    height="100%"
    :stripe="stripe"
    :row-style="RowStyle"
    style="width: 100%; height: 100%; display: block"
    ref="table"
    :span-method="spanMethod"
  >
    <el-table-column
      v-for="item in columns"
      :prop="item.field"
      :label="item.label"
      :width="item.width || 'auto'"
      :align="item.align || 'center'"
      :key="item.field"
    >
      <template slot-scope="scope">
        <RenderCell
          :row="scope.row"
          :render="item.render"
          :index="scope.$index"
          :column="item"
          v-if="item.render"
        />
        <span v-else>{{ scope.row[item.field] }}</span>
      </template>
      <el-table-column
        v-for="children in item.children"
        :prop="children.field"
        :label="children.label"
        :align="children.align || 'center'"
        :width="children.width || 'auto'"
      >
        <template slot-scope="scope">
          <RenderCell
            :row="scope.row"
            :render="children.render"
            :index="scope.$index"
            :column="children"
            v-if="children.render"
          />
          <span v-else>{{ scope.row[children.field] }}</span>
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import { Table, TableColumn } from "element-ui";

export default {
  name: "szTable",
  components: {
    ElTable: Table,
    ElTableColumn: TableColumn,
    RenderCell: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null,
        },
      },
      render: (h, data) => {
        const params = {
          row: data.props.row,
          index: data.props.index,
        };
        if (data.props.column) params.column = data.props.column;
        return data.props.render(h, params);
      },
    },
  },
  props: {
    columns: {
      type: Array,
    },
    tableData: {
      type: Array,
    },
    RowStyle: {
      type: Object,
    },
    spanMethod: {
      type: Function,
    },
    stripe: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    doLayout() {
      this.$refs.table.doLayout();
    },
  },
};
</script>

<style scoped lang="less">
::v-deep.el-table {
  background: unset;
  color: #fff;
  font-size: 14px;

  tr {
    background: unset;
  }

  thead {
    color: #fff;
    background: linear-gradient(
      180deg,
      rgba(64, 102, 141, 0.2) 0%,
      rgba(13, 181, 200, 0.51) 100%
    );

    &.is-group th.el-table__cell {
      background: unset;
    }
  }

  &--scrollable-x,
  &--scrollable-y {
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-corner {
      display: none;
    }

    ::-webkit-scrollbar-thumb {
      background: #434b55;
    }
  }

  th.el-table__cell {
    background: unset;
  }

  &--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: linear-gradient(
      180deg,
      rgba(64, 117, 150, 0.2) 0%,
      rgba(28, 61, 80, 0.71) 100%
    );
  }

  &--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background: linear-gradient(
      180deg,
      rgba(64, 117, 150, 0.2) 0%,
      rgba(28, 61, 80, 0.71) 100%
    );
  }

  & td.el-table__cell,
  & th.el-table__cell.is-leaf {
    border-bottom: none;
  }

  &--border {
    border-bottom: none;

    .el-table--group {
      border: none;
    }

    .el-table__cell,
    .el-table__body-wrapper
      .el-table--border.is-scrolling-left
      ~ .el-table__fixed {
      border-right: none;
    }

    th.el-table__cell,
    .el-table__fixed-right-patch {
      border-bottom: none;
    }
  }

  .el-table__cell {
    padding: 7px 0;
  }

  &--group {
    border: none;
  }

  &::before {
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
  }
}
</style>
